import agentData from '../agents/initialStates/agentData';
import totalscreenType from '../screens/totalscreenType';

const screenCreateTypes = totalscreenType.filter(
  item => item.createPath && item.type !== 'aiengagement'
);

const createCommands = [
  {
    id: 'create-agent',
    label: 'Create Agent',
    description: 'Start a new agent campaign',
    group: 'Create',
    path: agentData.createPath,
    sectionname: 'campaigns',
    icon: 'LineChartOutlined',
    keywords: ['new', 'agent', 'campaign'],
  },
  ...screenCreateTypes.map(item => ({
    id: `create-${item.type}`,
    label: `Create ${item.title}`,
    description: `Build a new ${item.title.toLowerCase()} screen`,
    group: 'Create',
    path: item.createPath,
    sectionname: 'screens',
    icon: 'ScreenOutlined',
    keywords: ['new', 'create', item.type, item.title?.toLowerCase()],
  })),
  {
    id: 'create-ai-engine',
    label: 'Create AI Engine',
    description: 'Configure a new AI Labs engine',
    group: 'Create',
    path: '/aiLabs/create',
    sectionname: 'aiLabs',
    icon: 'AIStarOutlined',
    keywords: ['new', 'create', 'ai labs', 'engine'],
  },
  {
    id: 'create-ab-test',
    label: 'Create A/B Test',
    description: 'Set up a new campaign A/B test',
    group: 'Create',
    path: '/abTest',
    sectionname: 'campaignABTest',
    icon: 'TogglesOutline',
    keywords: ['new', 'create', 'ab test', 'split test', 'experiment'],
  },
];

export default createCommands;
